import { h, Component } from 'preact';
import Store from 'store/store';
import { drawCard, feedSize } from 'utils/poster';
import { joinClasses } from 'utils/utils';

import HTML from 'components/core/html/html';

import s from 'components/bolt/quizPhotobooth/selector.sss';

export default class Selector extends Component {
	constructor(props) {
		super(props);
		this.selectPrev = this.selectPrev.bind(this);
		this.selectNext = this.selectNext.bind(this);
		this.confirm = this.confirm.bind(this);
		this.backClick = this.backClick.bind(this);
		this.canvasRef = this.canvasRef.bind(this);
	}
	componentDidMount() {
		this.draw();
	}
	componentDidUpdate() {
		this.draw();
	}

	draw() {
		if (this.cardCtx) {
			drawCard(this.props.cardData, this.cardCtx, 'feed');
		}
	}

	select(index) {}
	selectPrev() {
		const current = this.currentIndex;
		if (current > 0) this.select(current - 1);
		if (this.props.id === 'quizPhotobooth-background') {
			Store.emit('TRACK_QUIZPHOTOBOOTH_BACKGROUND_SELECTOR', 'prev');
		} else {
			Store.emit('TRACK_QUIZPHOTOBOOTH_QUOTE_SELECTOR', 'prev');
		}
	}
	selectNext() {
		const current = this.currentIndex;
		if (current < this.itemsCount - 1) this.select(current + 1);
		if (this.props.id === 'quizPhotobooth-background') {
			Store.emit('TRACK_QUIZPHOTOBOOTH_BACKGROUND_SELECTOR', 'next');
		} else {
			Store.emit('TRACK_QUIZPHOTOBOOTH_QUOTE_SELECTOR', 'next');
		}
	}

	confirm() {
		this.props.advanceStep();
	}

	onBack() {
		this.select(0);
	}
	backClick() {
		this.props.backStep();
		this.onBack();
		Store.emit('TRACK_QUIZPHOTOBOOTH_SELECTOR_BACK', this.props.id);
	}

	renderBackButton() {
		return (
			<button class={s.back} onClick={this.backClick} key="back">
				<HTML tag="span" content={this.props.appData?.copy?.baseCopy?.$QUIZPHOTOBOOTH_BACK} markdown inline />
			</button>
		);
	}

	canvasRef(e) {
		if (e) this.cardCtx = e.getContext('2d');
	}

	renderExtraCardContent() {
		const current = this.currentIndex;
		const count = this.itemsCount || 0;
		return (
			<div class={s.nav}>
				<button class={s.prev} onClick={this.selectPrev} disabled={current < 1} />
				<button class={s.next} onClick={this.selectNext} disabled={current >= count - 1} />
			</div>
		);
	}

	renderButtons() {
		const copy = this.props.appData?.copy?.baseCopy || {};
		return (
			<button class={s.button} type="button" onClick={this.confirm} key="button">
				{copy.$QUIZPHOTOBOOTH_CONTINUE || 'Looks Good'}
			</button>
		);
	}

	renderBreadcrumbs() {
		const current = this.currentIndex;
		return (
			<div class={s.breadcrumbs}>
				{[...Array(this.itemsCount)].map((_, index) => (
					<button
						class={joinClasses(s.crumb, current === index && s.active)}
						onClick={() => this.select(index)}
						key={index}
					/>
				))}
			</div>
		);
	}

	render() {
		return (
			<div class={s.container}>
				<h2 class={s.title}>{this.titleText}</h2>
				<div class={s.card} key="card">
					<canvas ref={this.canvasRef} {...feedSize} />
					{this.renderBackButton()}
					{this.renderExtraCardContent()}
				</div>
				{this.renderBreadcrumbs()}
				{this.renderButtons()}
			</div>
		);
	}
}